import debug from 'debug';

import { DebugLogsNamespace } from 'constants/debug-logs-namespace';
import { addLeadingZero } from 'helpers/time';

import { getDesktopApp } from './desktop-application/desktop-app';

const logDebug = debug(DebugLogsNamespace.AppDebug);
const logError = debug(DebugLogsNamespace.AppErrors);

export function saveLog(type: 'error' | 'info', message: string): void {
  const logger = type === 'error' ? logError : logDebug;

  logger(message);

  if (getDesktopApp().enableAdditionalLogs()) {
    const date = new Date();

    const time = [
      addLeadingZero(date.getHours()),
      addLeadingZero(date.getMinutes()),
      addLeadingZero(date.getSeconds()),
    ].join(':');

    const prefix = `[${type.toUpperCase()} ${time}]`;

    getDesktopApp().saveAdvancedLog([prefix, message]);
  }
}
